import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section-select_search" }
const _hoisted_2 = ["tabindex"]
const _hoisted_3 = ["name", "tabindex", "value", "disabled"]
const _hoisted_4 = ["name", "value", "disabled"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "list-item text-motserrat-16"
}
const _hoisted_7 = {
  key: 1,
  class: "list-item text-motserrat-16 postalcode-wrapper d-flex a-i-start j-content-end flex-column"
}
const _hoisted_8 = { class: "postalcode" }
const _hoisted_9 = {
  key: 0,
  class: "w-100"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-motserrat-16 text-nowrap text-center pt-1 pb-1" }, " Loading ", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "w-100"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-motserrat-16 text-nowrap text-center pt-1 pb-1" }, " Not found ", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "text text-raleway-13 error pointer t-danger mt-2"
}

import {
  ref,
  toRefs,
  watch,
  onBeforeUnmount,
  onMounted,
  computed,
} from "vue";
import { postalcodeType } from "@/store/modules/Postalcode/type";
import { OptionsType } from "@/store/modules/GeoPlace/type";
import { OpenGlobal } from "@/store/modules/User/type";
import { searchFunction } from "@/utils/search/search";
import { useField } from "vee-validate";
import { store } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectSearchComponent',
  props: {
    titleSelect: { type: Boolean },
    arrow: { type: Boolean },
    nameSelect: { type: Boolean },
    drop: { type: Boolean },
    placeholder: {},
    type: {},
    options: {},
    postalcheck: { type: Boolean },
    title: {},
    selected: {},
    default: {},
    tabindex: {},
    disabled: { type: Boolean },
    name: {},
    loading: { type: Boolean },
    store: {},
    solid: { type: Boolean },
    errorMin: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


const data = toRefs(props);

const openUserGlobal = ref(
  computed<OpenGlobal>(() => store.getters.getUserOpenElement)
);

const selected = ref(
  data.default.value
    ? data.default.value
    : data.options.value.length > 0
    ? (data.options.value[0] as OptionsType)?.name
    : (data.options.value[0] as postalcodeType)?.postal_code || ""
);

const valueInput = ref(" ");

const inputName = ref(data.name?.value || "search-select");

const updateOpen = (value?: boolean) => {
  if (!data.disabled?.value) {
    if (data.name?.value !== openUserGlobal.value.name)
      return store.commit("updateUserOpenGlobal", {
        value: value || true,
        name: data.name?.value,
      });
    return store.commit("updateUserOpenGlobal", {
      value: value || !openUserGlobal.value.value,
      name: data.name?.value,
    });
  }
};

const first = ref(true);
const searchType = ref(data.options.value);
const { value, resetField, errorMessage } = useField(
  inputName.value,
  (value: string) => value
);

watch(
  () => props.options,
  () => {
    if (props.options.length <= 0) {
      first.value = false;
      resetField({
        value: "",
      });
      selected.value = "";
    }
    if (data.options.value.length === 1) {
      first.value = false;

      selected.value = data?.options?.value[0].id?.toString();

      resetField({
        value: data.postalcheck?.value
          ? (data?.options?.value as OptionsType[])[0]?.postalcode ||
            (data?.options?.value as postalcodeType[])[0]?.postal_code
          : (data?.options?.value as OptionsType[])[0]?.name ||
            (data.type?.value === "country" &&
              (data?.options?.value as postalcodeType[])[0]?.geo_country) ||
            (data.type?.value === "region" &&
              (data?.options?.value as postalcodeType[])[0]?.geo_region) ||
            (data.type?.value === "city" &&
              (data?.options?.value as postalcodeType[])[0]?.geo_name) ||
            (data?.options?.value as postalcodeType[])[0]?.geo_name,
      });

      if (data.store && data.store?.value && data.nameSelect?.value)
        store.commit(
          data.store.value,
          (data.options.value[0] as OptionsType).name
        );
      if (data.store && data.store.value && !data.nameSelect?.value)
        store.commit(data.store.value, data.options.value[0]);
    }
    if (props.options.length > 0) {
      first.value = false;
      searchType.value =
        data.type?.value !== "country" &&
        data.type?.value !== "region" &&
        data.type?.value !== "city"
          ? searchFunction(
              value.value,
              data.options.value,
              data.postalcheck?.value || false
            )
          : data.options.value;
    }
  }
);

watch(
  () => data?.default?.value,
  () => {
    selected.value = data?.default?.value;
    valueInput.value = data?.default?.value;
    resetField({
      value: data?.default?.value,
    });
    if (data.store?.value)
      store.commit(data.store?.value, data?.default?.value);
  }
);

watch(
  () => data?.selected?.value,
  () => {
    selected.value = (data?.selected?.value as OptionsType)?.id?.toString();

    resetField({
      value: data.postalcheck?.value
        ? (data?.selected?.value as OptionsType)?.postalcode ||
          (data?.selected?.value as postalcodeType)?.postal_code
        : (data?.selected?.value as OptionsType)?.name ||
          (data.type?.value === "country" &&
            (data?.selected?.value as postalcodeType)?.geo_country) ||
          (data.type?.value === "region" &&
            (data?.selected?.value as postalcodeType)?.geo_region) ||
          (data.type?.value === "city" &&
            (data?.selected?.value as postalcodeType)?.geo_name) ||
          (data?.selected?.value as postalcodeType)?.geo_name,
    });
  }
);
const changeSelected = (option: string | postalcodeType) => {
  first.value = false;
  if (typeof option === "string") {
    selected.value = option;
    valueInput.value = option;
  } else {
    selected.value = option.id.toString();
    valueInput.value = data.postalcheck?.value
      ? option.postal_code
      : (data.type?.value === "country" &&
          ((data?.selected?.value as postalcodeType)?.geo_country ||
            (option as postalcodeType)?.geo_country)) ||
        (data.type?.value === "region" &&
          ((data?.selected?.value as postalcodeType)?.geo_region ||
            (option as postalcodeType)?.geo_region)) ||
        (data.type?.value === "city" &&
          ((data?.selected?.value as postalcodeType)?.geo_name ||
            (option as postalcodeType)?.geo_name)) ||
        (data?.selected?.value as postalcodeType)?.geo_name;
  }

  resetField({
    value: valueInput.value,
  });

  if (
    data.type?.value !== "country" &&
    data.type?.value !== "region" &&
    data.type?.value !== "city"
  )
    searchType.value = searchFunction(
      valueInput.value,
      data.options.value,
      data.postalcheck?.value || false
    );
  else searchType.value = data.options.value;

  if (data.store && data.store.value) store.commit(data.store.value, option);
};
const updateValue = (event: Event) => {
  first.value = false;
  const value = (event.target as HTMLInputElement).value;

  resetField({
    value,
  });

  if (
    data.type?.value !== "country" &&
    data.type?.value !== "region" &&
    data.type?.value !== "city"
  )
    searchType.value = searchFunction(
      valueInput.value,
      data.options.value,
      data.postalcheck?.value || false
    );
  else searchType.value = data.options.value;
};
const close = () =>
  store.commit("updateUserOpenGlobal", {
    value: false,
    name: data.name?.value,
  });
onBeforeUnmount(() => document.removeEventListener("click", close));
onMounted(() => document.addEventListener("click", close));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["select-form select-search", {
        'background-none-arrow': _ctx.arrow,
        'bg-white50': _ctx.disabled,
        'b-solid-blue100': _ctx.solid,
        'b-solid-blue100-2px': !_ctx.solid,
        'error-input country': _unref(data)?.errorMin?.value && _unref(errorMessage),
      }]),
      tabindex: _ctx.tabindex,
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (!_unref(data)?.drop?.value && updateOpen()), ["stop"]))
    }, [
      _withDirectives(_createElementVNode("p", { class: "text-motserrat-16 text-nowrap" }, _toDisplayString(_unref(value) || _ctx.title), 513), [
        [_vShow, !_unref(data).drop?.value]
      ]),
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(["text-motserrat-16", {
          open: openUserGlobal.value.value && openUserGlobal.value.name === inputName.value,
          'display-none':
            _unref(data).type?.value === 'country' ||
            _unref(data).type?.value === 'region' ||
            _unref(data).type?.value === 'city',
        }]),
        onFocus: _cache[0] || (_cache[0] = ($event: any) => (updateOpen(true))),
        onkeydown: "return event.key != 'Enter'",
        name: inputName.value,
        onInput: updateValue,
        tabindex: props.tabindex,
        value: _ctx.titleSelect ? _unref(value) || _ctx.title : _unref(value),
        disabled: _unref(data).disabled?.value || false,
        autocomplete: "new-password"
      }, null, 42, _hoisted_3), [
        [_vShow, _unref(data).drop?.value]
      ]),
      _createElementVNode("ul", {
        class: _normalizeClass(["list", {
          hidden: !openUserGlobal.value.value || openUserGlobal.value.name !== inputName.value,
        }])
      }, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["text-motserrat-16", {
            open: openUserGlobal.value.value && openUserGlobal.value.name === inputName.value,
            'display-none':
              _unref(data).type?.value === 'country' ||
              _unref(data).type?.value === 'region' ||
              _unref(data).type?.value === 'city',
          }]),
          onkeydown: "return event.key != 'Enter'",
          name: inputName.value,
          onInput: updateValue,
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
          value: _unref(value),
          disabled: _unref(data).disabled?.value || false,
          autocomplete: "new-password"
        }, null, 42, _hoisted_4), [
          [_vShow, !_unref(data).drop?.value]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchType.value, (option, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: option.id + i || i,
            class: "w-100",
            onClick: _withModifiers(($event: any) => (
            _unref(data)?.drop?.value && close(),
              changeSelected(
                (option as OptionsType)?.name || (option as postalcodeType)
              )
          ), ["stop"])
          }, [
            (!_unref(data).postalcheck?.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, _toDisplayString((option as OptionsType)?.name ||
              (_unref(data).type?.value === "country" &&
                (option as postalcodeType)?.geo_country) ||
              (_unref(data).type?.value === "region" &&
                (option as postalcodeType)?.geo_region) ||
              (_unref(data).type?.value === "city" &&
                (option as postalcodeType)?.geo_name) ||
              (option as postalcodeType)?.geo_name), 1))
              : _createCommentVNode("", true),
            (_unref(data).postalcheck?.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createElementVNode("p", null, _toDisplayString((option as OptionsType)?.name ||
                (option as postalcodeType)?.geo_name), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString((option as postalcodeType)?.postal_code), 1)
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_5))
        }), 128)),
        (_unref(data).loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          : _createCommentVNode("", true),
        (
            !first.value &&
            searchType.value.length <= 0 &&
            _ctx.options.length >= 0 &&
            !_unref(data).loading.value &&
            _unref(data).type?.value !== 'country' &&
            _unref(data).type?.value !== 'region' &&
            _unref(data).type?.value !== 'city'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          : _createCommentVNode("", true)
      ], 2)
    ], 10, _hoisted_2),
    (_unref(errorMessage) && !_unref(data)?.errorMin?.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})